import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Table, IconButton, Dialog, Button } from 'react-toolbox'
import CSSModules from 'react-css-modules'
import _ from 'lodash'

import PowerComponents from 'components/form/notebookPowerComponents/index'
import VoltageConfigItem from './VoltageConfigItem'

import styles from './styles.scss'

class VoltageConfig extends Component {
  constructor(props) {
    super(props)

    this.allParts = []
  }


/**
 *
 * Generates a Voltage object for a Voltage configuration
 *
 * @param {any} curValue
 * @memberof VoltageConfig
 * @returns {Object} a Voltage item
 */
  generateVoltageConfig(curValue) {
    const voltageItem = {
      railType: curValue.railType,
    }

    return voltageItem
  }

/**
 *
 * Generates an array of all Voltages of some configuration
 *
 * @returns {Array} an array Voltage items
 * @memberof VoltageConfig
 */
  generateVoltageConfigs() {
    this.allParts = this.props.values

    // generate every configuration using the first part in the configuration
    return this.allParts.map(config => this.generateVoltageConfig(config[0]))
  }

  onAddPart(partConfig = {}) {
    return () => {
      this.props.onTogglePopup()
      this.props.onUpdateCurConfig(partConfig)
    }
  }

  render() {
    const {
      edpPeak,
      edpContinuous,
      outputVoltage,
      filterStatus,
      initFilters,
      onDeletePart,
      onTogglePopup,
      togglePopup,
      onUpdateCurConfig,
      onUpdatePhaseCount,
      onUpdateEfficiency,
      onUpdateEdpPeak,
      onUpdateEdpContinuous,
      onUpdateOutputVoltage,
      values,
      powerComponents,
      powerComponentsTypes,
      onAddComponent,
      onUpdateComponent,
      onRemoveComponent,
      showPowerComponents,
      setEditPart,
      isEdit,
      setIsAddPart,
      isAddPart
    } = this.props
    const voltageConfigs = this.generateVoltageConfigs()

    return <div>
      { voltageConfigs.map((config, index) => {
        const curPart = this.allParts[index]
        return (
          <React.Fragment key={index}>
            <VoltageConfigItem
              key={index}
              config={config}
              index={index}
              curPart={curPart}
              filterStatus={filterStatus}
              edpPeak={edpPeak}
              edpContinuous={edpContinuous}
              outputVoltage={outputVoltage}
              initFilters={initFilters}
              onDeletePart={onDeletePart}
              onTogglePopup={onTogglePopup}
              togglePopup={togglePopup}
              onUpdateCurConfig={onUpdateCurConfig}
              onUpdatePhaseCount={onUpdatePhaseCount}
              onUpdateEfficiency={onUpdateEfficiency}
              onUpdateEdpPeak={onUpdateEdpPeak}
              onUpdateEdpContinuous={onUpdateEdpContinuous}
              onUpdateOutputVoltage={onUpdateOutputVoltage}
              setEditPart={setEditPart}
              isEdit={isEdit}
              setIsAddPart={setIsAddPart}
              isAddPart={isAddPart}
            />
            {showPowerComponents && 
              <p class={styles.subHeading}>Power Components</p> && 
              <PowerComponents
                railType={curPart[0].railType} 
                onUpdateComponent={onUpdateComponent}
                onRemoveComponent={onRemoveComponent}
                onAddComponent={onAddComponent}
                values={values}
                powerComponents={powerComponents}
                powerComponentsTypes={powerComponentsTypes}
              />
            }
          </React.Fragment>
        )
      }) }
    </div>
  }
}

VoltageConfig.propTypes = {
  values: PropTypes.array.isRequired,
  togglePopup: PropTypes.bool.isRequired,

  onTogglePopup: PropTypes.func.isRequired,
  onDeletePart: PropTypes.func.isRequired,
  onUpdateCurConfig: PropTypes.func.isRequired,
}

export default CSSModules(VoltageConfig, styles)
